import type { LucideIcon } from "lucide-react";

export function lucideSelectIcon(Icon: LucideIcon, size = 18) {
  return function SelectIcon({ className }: { className?: string }) {
    return <Icon className={className} size={size} color="currentColor" />;
  };
}
